import React from "/vendor/react";

import { CheckIcon } from "/lib/component/icon";
import MenuItem from "./MenuItem";

const GoToDefinition = props => <MenuItem {...props} />;

GoToDefinition.displayName = "ToolbarMenuItems.GoToDefinition";

GoToDefinition.defaultProps = {
  title: "Go to definition",
  titleCondensed: "Definition",
  description: "Open the configuration of this check.",
  icon: <CheckIcon />,
};

export default GoToDefinition;
